import { forwardRef } from 'react'
import { IconProps } from '../Types'
import { filterDOMProps } from '@react-aria/utils'

export const LinkedIn = forwardRef<SVGSVGElement, IconProps>(({ color, size = 20, ...rest }, forwardedRef) => {
  const domProps = filterDOMProps(rest, { labelable: true, propNames: new Set(['role']) })
  if (color) {
    return (
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...domProps}>
        <path
          d="M14.375 2.5H5.625C3.89938 2.5 2.5 3.89938 2.5 5.625V14.375C2.5 16.1006 3.89938 17.5 5.625 17.5H14.375C16.1012 17.5 17.5 16.1006 17.5 14.375V5.625C17.5 3.89938 16.1012 2.5 14.375 2.5ZM7.5 14.375H5.625V7.5H7.5V14.375ZM6.5625 6.7075C5.95875 6.7075 5.46875 6.21375 5.46875 5.605C5.46875 4.99625 5.95875 4.5025 6.5625 4.5025C7.16625 4.5025 7.65625 4.99625 7.65625 5.605C7.65625 6.21375 7.16687 6.7075 6.5625 6.7075ZM15 14.375H13.125V10.8725C13.125 8.7675 10.625 8.92688 10.625 10.8725V14.375H8.75V7.5H10.625V8.60313C11.4975 6.98688 15 6.8675 15 10.1506V14.375Z"
          fill={color}
        />
      </svg>
    )
  }

  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
      {...domProps}
    >
      <path
        d="M14.375 2.5H5.625C3.89938 2.5 2.5 3.89938 2.5 5.625V14.375C2.5 16.1006 3.89938 17.5 5.625 17.5H14.375C16.1012 17.5 17.5 16.1006 17.5 14.375V5.625C17.5 3.89938 16.1012 2.5 14.375 2.5ZM7.5 14.375H5.625V7.5H7.5V14.375ZM6.5625 6.7075C5.95875 6.7075 5.46875 6.21375 5.46875 5.605C5.46875 4.99625 5.95875 4.5025 6.5625 4.5025C7.16625 4.5025 7.65625 4.99625 7.65625 5.605C7.65625 6.21375 7.16687 6.7075 6.5625 6.7075ZM15 14.375H13.125V10.8725C13.125 8.7675 10.625 8.92688 10.625 10.8725V14.375H8.75V7.5H10.625V8.60313C11.4975 6.98688 15 6.8675 15 10.1506V14.375Z"
        fill="#1275B1"
      />
    </svg>
  )
})

export default LinkedIn
